<template>
  <div class="comment">
    <img :src="comment.icon" :alt="comment.publisher" class="comment-avatar" />
    <div class="comment-content">
      <div class="comment-header">
        <div class="comment-author">{{ comment.publisher }}</div>
        <div class="comment-time">{{ comment.publishedDateTimeString }}</div>
      </div>
      <p>{{ comment.content }}</p>
      <div class="comment-actions">
        <div class="comment-action" @click="handleLike">
          <i :class="['fas', 'fa-thumbs-up', { liked: comment.isLiked }]"></i>
          <span>{{ comment.likes }}</span>
        </div>
        <div class="comment-action" @click="handleReply">
          <i class="fas fa-reply"></i>
          <span>回覆</span>
        </div>
      </div>
      <div
        class="comment comment-reply"
        v-for="reply in comment.replies"
        :key="reply.id"
      >
        <img :src="reply.icon" :alt="reply.publisher" class="comment-avatar" />
        <div class="comment-content">
          <div class="comment-header">
            <div class="comment-author">{{ reply.publisher }}</div>
            <div class="comment-time">
              {{ reply.publishedDateTimeString }}
            </div>
          </div>
          <p>{{ reply.content }}</p>
          <div class="comment-actions">
            <div class="comment-action" @click="handleLike">
              <i :class="['fas', 'fa-thumbs-up', { liked: reply.isLiked }]"></i>
              <span>{{ reply.likes }} </span>
            </div>
            <div class="comment-action" @click="handleReply">
              <i class="fas fa-reply"></i>
              <span>回覆</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecipeComment",
  props: {
    comment: {
      type: Object,
      required: true,
      default: () => ({
        id: null,
        avatar: "",
        author: "",
        time: "",
        content: "",
        likes: 0,
        isLiked: false,
      }),
    },
  },
  emits: ["like", "reply"],
  methods: {
    handleLike() {
      this.$emit("like", this.comment.id);
    },
    handleReply() {
      this.$emit("reply", this.comment.id);
    },
  },
};
</script>

<style scoped>
.comment {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  padding: 16px;
  background: var(--card-background);
  border-radius: 12px;
  box-shadow: var(--shadow);
}
.comment-reply {
  background-color: rgb(250, 250, 250);
}
.comment-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.comment-content {
  flex: 1;
}

.comment-header {
  margin-bottom: 8px;
}

.comment-author {
  font-weight: 600;
}

.comment-time {
  color: var(--text-secondary);
  font-size: 0.8rem;
}

.comment-actions {
  display: flex;
  gap: 16px;
  margin-top: 8px;
}

.comment-action {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-secondary);
  font-size: 0.9rem;
  cursor: pointer;
}

.comment-action:hover {
  color: var(--primary);
}

.comment-action .liked {
  color: var(--primary);
}
</style>
